<template>
  <div class="digital_home_video">
        <div class="container">
            <img style="position: absolute; width: 80%;
                    top: 50%; height: 100%; border-radius: 10px;
                    left: 50%; transform: translate(-50%, -50%);"
                    :src="cover ? cover : require('../../assets/image/资源107.png')">
            <img style="position: absolute;
                    top: 50%; cursor: pointer;
                    left: 50%; transform: translate(-50%, -50%);"
                    @click="playVideo"
                    src="../../assets/image/37.视频播放icon_1.png">
            <div class="video_dialog">
                <div class="dialog_left">
                    <p style="color: #fff;">{{ company ? company : successfulProjects[0].title }}</p>
                    <div style="display: flex; align-items: center;">
                        <span style="color: #54d1ef; margin-right: 2%; font-size: 0.7rem;">预约产品演示</span>
                        <img style="cursor: pointer;" @click="goProduct" src="../../assets/digitalHome/资源 51.png">
                    </div>
                </div>
                <div class="dialog_right">
                    <p>
                        {{ company_content ? company_content : successfulProjects[0].content }}
                    </p>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="centerDialogVisible"
            @close="closeVideo"
            width="100%"
            height="100%"
            center>
            <div class="video_open">
                <video id="myVideo" class="video-js">
                    <source
                        :src="url"
                        type="video/mp4"
                    >
                    <!-- <source
                        :src="url"
                        type="video/quicktime"
                    > -->
                </video>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {  successfulProjects } from "../../util/constant"
export default {
    data(){
        return{
            successfulProjects,
            centerDialogVisible: false,
        }
    },
    props: {
        url : String,
        cover: String,
        company: String,
        company_content: String,
    },
    methods: {
        initVideo() {
            let myPlayer = this.$video(myVideo, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: "muted",
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                width: 1350,
                height: 680
            });
        },
        playVideo() {
            this.centerDialogVisible = true
            setTimeout(()=>{
                this.initVideo()
            },0)
        },
        closeVideo() {
            let myPlayer = this.$video(document.getElementById('myVideo'))
            if(myPlayer){
                // 暂停视频
                myPlayer.pause();
                // 重置播放进度
                // myPlayer.currentTime = 0;
                // 清空视频源（可选，根据需求）
                // myPlayer.src = "";
            }
            this.centerDialogVisible = false

        },
        goProduct(){
            this.$router.push({path: '/about#contact'})
        }
    }
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog{
    background-color: #000000;
    // opacity: 0.9;
    display: flex;
    justify-content: center;
    margin-top: 10vh !important;
    width: 90% !important;
}
.digital_home_video{
        width: 100%;
        background-color: #1e1d1d;
        .container{
            margin: 0 auto;
            height: 580px;
            width: 70%;
            position: relative;
            background-size: cover;
            .video_dialog{
                width: 80%;
                left: 10%;
                background-color: #000000;
                position: absolute;
                bottom: 0;
                display: flex;
                padding: 2rem 5rem;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
                .dialog_left{
                    width: 30%;
                    margin: auto;
                    p{
                        color: rgb(255, 255, 255);
                        font-size: 1rem;
                        letter-spacing: 1px;
                        padding-bottom: 2%;
                    }
                }
                .dialog_right{
                    width: 69%;
                    display: flex;
                    align-items: center;
                    p{
                        color: rgb(255, 255, 255);
                        font-size: 0.75rem;
                        line-height: 1.7;
                        letter-spacing: 0.5px;
                        border-left: 1px solid rgb(151 151 151);
                        padding-left: 5%;
                    }
                }
            }
        }
    }
</style>